import React from 'react';
import PropTypes from 'prop-types';
import RowNumbers from '../../../../components/seats/seatSelection/RowNumbers';
import RowSeats from '../../../../components/seats/seatSelection/RowSeats';
import ExitRow from '../../../../icons/ExitRow';
import ClassNames from 'classnames';

const RowSeatContainer = ({ row, rowNumber, exitRow, selectedPassenger, selectSeat }) => {
  if (!row || !row.length || !rowNumber) {
    return null;
  }
  let middleRow = parseInt(row.length / 2, 10) - 1; // -1 to get index of row middle
  rowNumber = rowNumber - 1; // -1 to get index

  if (rowNumber === 1) {
    return (
      <div key={`seats-row-${rowNumber}`}>
        <div className='seats-row'>
          <RowNumbers row={row} rowNumber={rowNumber} middleRow={middleRow} />
        </div>
        <div className='seats-row'>
          <RowSeats
            row={row}
            rowNumber={rowNumber}
            middleRow={middleRow}
            selectSeat={selectSeat}
            selectedPassenger={selectedPassenger}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={ClassNames({ 'exit-row': rowNumber - 1 === exitRow })}>
      <div className='seats-row' key={`seats-row-${rowNumber}`}>
        <RowSeats
          row={row}
          rowNumber={rowNumber}
          middleRow={middleRow}
          selectSeat={selectSeat}
          selectedPassenger={selectedPassenger}
        />
      </div>
      {rowNumber + 1 !== exitRow ? null : <ExitRow className='exit-row' />}
    </div>
  );
};

RowSeatContainer.propTypes = {
  row: PropTypes.arrayOf(PropTypes.object),
  rowNumber: PropTypes.number,
  exitRow: PropTypes.number,
  selectedPassenger: PropTypes.string,
  selectSeat: PropTypes.func,
};

export default RowSeatContainer;



// WEBPACK FOOTER //
// ./src/containers/seats/common/seatSelection/RowSeatContainer.js